import { createBrowserHistory } from "history";

// exposes a singleton browser history object
export default createBrowserHistory();